import { render, staticRenderFns } from "./ApplicationEducationTransfer.vue?vue&type=template&id=eba3146c&scoped=true&"
import script from "./ApplicationEducationTransfer.vue?vue&type=script&lang=js&"
export * from "./ApplicationEducationTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationEducationTransfer.vue?vue&type=style&index=0&id=eba3146c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba3146c",
  null
  
)

export default component.exports